import React from 'react';
import { ArrowRight } from 'lucide-react';

const BOOK_DEMO_URL =
  'https://wa.me/60166346575?text=Hi%2C%20I%20would%20like%20to%20book%20a%20demo%20for%20AinaSuite%20and%20discuss%20the%20suitable%20plan%20for%20my%20business%20requirements.';

export default function FinalCTA() {
  return (
    <section id="start" className="finalCta">
      <div className="container">
        <div className="finalCta__card reveal">
          <div className="finalCta__bg" aria-hidden="true" />
          <h2 className="finalCta__title">Your customers are messaging right now.</h2>
          <p className="finalCta__desc">
            Give them the instant, on-brand reply they expect — and capture every lead automatically.
          </p>
          <div className="finalCta__actions">
            <a href="#pricing" className="btn btn--white btn--lg">
              See pricing <ArrowRight size={18} />
            </a>
            <a
              href={BOOK_DEMO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--outlineWhite btn--lg"
            >
              Book a demo
            </a>
          </div>
          <p className="finalCta__note">Plans from RM 399 / month · Cancel anytime · Enterprise plans available</p>
        </div>
      </div>
    </section>
  );
}
